import { render, staticRenderFns } from "./lens.vue?vue&type=template&id=64103222&scoped=true"
import script from "./lens.vue?vue&type=script&lang=js"
export * from "./lens.vue?vue&type=script&lang=js"
import style0 from "./lens.vue?vue&type=style&index=0&id=64103222&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64103222",
  null
  
)

export default component.exports